import { gql } from '@apollo/client';

export const DELETE_PLAN = gql`
    mutation deletePlan($idPlan: ID!){
        deletePlan(idPlan: $idPlan)
    }
`;
